export default "__VITE_ASSET__DhgQOuZ1__"